import { ReactElement } from 'react';

import GlobalConfig from '^components/GlobalConfig';
import CarColorViewer from '^pages/CarColorViewer';

const App = (): ReactElement => (
  <GlobalConfig>
    <CarColorViewer />
  </GlobalConfig>
);

export default App;
